import { MEDICAL_DIAGNOSIS_OPTIONS } from './constants';
import { MEDICAL_DIAGNOSIS_SCHEMA } from './validationSchema';

import type {
  IIntakeMedicalDiagnosis,
  IntakeMedicalDiagnosisPayload,
} from '../../../../../../store/questionnaires/intake';
import type { SelectionEntry } from '../../../../../common';
import type { MedicalDiagnosisFieldName, MedicalDiagnosisFormValues } from './types';

export function toMedicalDiagnosisPayload(
  values: MedicalDiagnosisFormValues,
): IntakeMedicalDiagnosisPayload {
  return {
    diagnosis_name: values.diagnosis_name || null,
    diagnosis_provider_name: values.diagnosis_provider_name || null,
    diagnosis_city: values.diagnosis_city || null,
    diagnosis_state: values.diagnosis_state || null,
    diagnosis_year: values.diagnosis_year === '' ? null : Number(values.diagnosis_year),
  };
}

export function toMedicalDiagnosisFieldPayload<K extends MedicalDiagnosisFieldName>(
  name: K,
  values: MedicalDiagnosisFormValues,
): IntakeMedicalDiagnosisPayload {
  const data: IntakeMedicalDiagnosisPayload = {};
  data[name] = toMedicalDiagnosisPayload(values)[name];
  return data;
}

export function mapMedicalDiagnosisRowToValues(
  row: IIntakeMedicalDiagnosis,
): MedicalDiagnosisFormValues {
  return {
    diagnosis_name: row.diagnosis_name ?? '',
    diagnosis_provider_name: row.diagnosis_provider_name ?? '',
    diagnosis_city: row.diagnosis_city ?? '',
    diagnosis_state: row.diagnosis_state ?? '',
    diagnosis_year: row.diagnosis_year != null ? String(row.diagnosis_year) : '',
  };
}

export function getMedicalDiagnosisLabel(row: IIntakeMedicalDiagnosis): string {
  const name =
    MEDICAL_DIAGNOSIS_OPTIONS.find((option) => option.value === row.diagnosis_name)?.label ??
    row.diagnosis_name ??
    '';
  return row.diagnosis_year != null ? `${name} - ${row.diagnosis_year}` : name;
}

export function getMedicalDiagnosisDeleteMessage(row: IIntakeMedicalDiagnosis): string {
  return `You are about to delete diagnosis "${row.diagnosis_name ?? ''}"`;
}

export function getMedicalSelectionDeleteMessage(
  noun: string,
  row: SelectionEntry,
): string {
  return `You are about to delete ${noun} "${row.value}"`;
}

export function areIntakeMedicalDiagnosesComplete(
  rows: ReadonlyArray<IIntakeMedicalDiagnosis>,
): boolean {
  return rows.every((row) => MEDICAL_DIAGNOSIS_SCHEMA.isValidSync(mapMedicalDiagnosisRowToValues(row)));
}
